import type { FC } from "react";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import {
  DateRangePicker,
  IconFilterListOutlined,
  IconPlaceOutlined,
  ToolbarSearchableSelectPopover,
  type BookingsToolbarFilterOption,
} from "design-components";

export interface DashboardPageHeaderProps {
  logoSrc: string;
  logoAlt: string;
  lastUpdatedLabel: string;
  dateRange: [Date | null, Date | null];
  onDateRangeChange: (range: [Date | null, Date | null]) => void;
  dateRangeLabel?: string;
  locationOptions: BookingsToolbarFilterOption[];
  selectedLocationIds: string[];
  onLocationsChange: (ids: string[]) => void;
  locationsLoading: boolean;
  onFilterClick: () => void;
}

export const DashboardPageHeader: FC<DashboardPageHeaderProps> = ({
  logoSrc,
  logoAlt,
  lastUpdatedLabel,
  dateRange,
  onDateRangeChange,
  dateRangeLabel,
  locationOptions,
  selectedLocationIds,
  onLocationsChange,
  locationsLoading,
  onFilterClick,
}) => (
  <Box className="operator-dashboard__header-row">
    <Box component="img" src={logoSrc} alt={logoAlt} className="operator-dashboard__logo" />
    <Box className="operator-dashboard__header-trailing">
      <Typography component="p" variant="body2" className="operator-dashboard__meta">
        {lastUpdatedLabel}
      </Typography>
      <Box className="operator-dashboard__controls-card">
        <Box className="operator-dashboard__date-wrap">
          <DateRangePicker
            value={dateRange}
            onChange={onDateRangeChange}
            triggerLabel={dateRangeLabel}
          />
        </Box>
        <Box className="users-toolbar__divider-wrap">
          <Divider orientation="vertical" flexItem className="users-toolbar__divider" />
        </Box>
        <Box className="operator-dashboard__location-wrap">
          <Box className="operator-dashboard__location-inner">
            <IconPlaceOutlined aria-hidden className="operator-dashboard__location-pin" size={24} />
            <ToolbarSearchableSelectPopover
              options={locationOptions}
              value={selectedLocationIds}
              onChange={onLocationsChange}
              allValue=""
              loading={locationsLoading}
              leadingIcon={null}
              ariaLabel="Filter by location"
              searchPlaceholder="Search locations"
              singleSelect
              emptySelectionDisplay="Location name"
              showTriggerChevron
            />
          </Box>
        </Box>
        <Box className="users-toolbar__divider-wrap">
          <Divider orientation="vertical" flexItem className="users-toolbar__divider" />
        </Box>
        <IconButton
          type="button"
          aria-label="Open filters"
          onClick={onFilterClick}
          className="operator-dashboard__filter-btn"
          size="small"
        >
          <IconFilterListOutlined aria-hidden size={24} />
        </IconButton>
      </Box>
    </Box>
  </Box>
);
